  <!-- Error screen shown when getOTCConfig API fails or configuration is not found -->
<div class="option-otc" *ngIf="getActiveStep() === beforeStep1Active">
  <f-alert variant="error" *ngIf="rootScope.activeCustTab?.otcData?.deliveryMethodConfigMiss">{{noConfigForDeliveryMethods}}</f-alert>
    <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData?.deliveryMethodApiFail">
      There was problem loading the data.<a href="javascript:void('0')" (click)="otcService.getOTCConfig()"
      class="btn-alert">Try again.</a> </f-alert>
</div>


 <!-- Stepper Header and container for all 3 steps -->
<div class="otc-panel" *ngIf="getActiveStep() !== beforeStep1Active">

  <!-- Stepper Header of OTC  -->
    <div class="otc-container">
      <div class="step-container flex justify-space-between">
          <span [class]="(getActiveStep() === onStep1Active || getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? 'step-val active': 'step-val'">
            <span [class]="(getActiveStep() === onStep1Active || getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? (rootScope.activeCustTab.otcData.deliveryMethodSDataMiss ? 'step-circle failure' : 'step-circle active'): 'step-circle'">   
          <span class="step-no"> <span *ngIf="(getActiveStep() === onStep1Active) && !rootScope.activeCustTab.otcData.deliveryMethodSDataMiss">1</span>
           <span *ngIf="( getActiveStep() === onStep2Active || getActiveStep() === onStep3Active)"> <f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span> 
                       <span *ngIf="rootScope.activeCustTab.otcData.deliveryMethodSDataMiss"> <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon></span> 

          </span></span>Select Delivery Method/Address</span>
          <!-- CCR3-17181 Design Language Selection Dropdown heading on OTC Delivery Step 1 -->
            <span class="hide">Select Language and Delivery Method</span>
          
                    <span [class]="(getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? 'step-val active': 'step-val'">
          <span [class]="(getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? ( (rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.otcDenied) ? 'step-circle failure' : 'step-circle active'): 'step-circle'">
          <span class="step-no"><span *ngIf="!rootScope.activeCustTab.otcData.notEligiblePhoneNumber && !rootScope.activeCustTab.otcData.otcDenied && !rootScope.activeCustTab.otcData.sendOTCSuccess">2</span>  
          <span *ngIf="rootScope.activeCustTab.otcData.sendOTCSuccess"> <f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span> 
    
            <span *ngIf="(rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.otcDenied)"> <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon></span> 
          </span></span>Confirm and Send</span> 
  
         <span [class]="getActiveStep() === onStep3Active ? 'step-val active': 'step-val'">
          <span [class]="getActiveStep() === onStep3Active ? ( (rootScope.activeCustTab.otcData.otcExpired) || (rootScope.activeCustTab.otcData.validateOtcLocked) ? 'step-circle failure' : 'step-circle active'): 'step-circle'">
          <span class="step-no"><span *ngIf="!rootScope.activeCustTab.otcData.validateOtcLocked && !rootScope.activeCustTab.otcData.otcExpired">3</span>      
            <span *ngIf="(rootScope.activeCustTab.otcData.otcExpired) || (rootScope.activeCustTab.otcData.validateOtcLocked)"> <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon></span> 
          </span></span> Validate OTC </span> 
      </div>
       <p class="steps-content step1-content" *ngIf="getActiveStep() === onStep1Active && !rootScope.activeCustTab.otcData.deliveryMethodSDataMiss">If the caller is speaking a language different from the default, ask if they would like the message sent in their preferred language. If yes, update the language dropdown accordingly.</p>
    </div> 
  </div>

 <!-- Step 1 Where User choose Select Delivery Method/Address -->
     <f-alert variant="success" *ngIf="rootScope.activeCustTab.otcData.unStopPhoneNumberStatusApiSuccess" class="status-msg "><p>Texts unblocked successfully. You will now receive messages on this number.</p></f-alert>
     <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.unStopPhoneNumberStatusApiFailure"  class="status-msg"><p>Failed to remove the STOP status for the selected phone number.</p><p><strong>Error detail-</strong> {{rootScope.activeCustTab.otcData.unStopPhoneNumberStatusApiFailureDetails}}</p></f-alert>
<!-- CCR3-17181 Design Language Selection Dropdown on OTC Delivery Step 1 -->
      <div class="row row-bottom-space" *ngIf="getActiveStep() === onStep1Active && !rootScope.activeCustTab.otcData.deliveryMethodSDataMiss">
         <div class="language-selection col-md-6">
    <app-alight-smart-search-drop-down [group]="languageForm" [controlName]="'language'" [required]="true"
      description="clientName" [clearSeleAvailable]="true" [disable]="languageDropdownOptions.length === 1" label="Language"
      [value]="'clientName'" [list]="languageDropdownOptions">
    </app-alight-smart-search-drop-down>
    <div class="error-wrapper" *ngIf="languageForm.get('language')?.touched && languageForm.get('language')?.hasError('invalidOption')">
      <f-alert variant="error" class="status-msg">Please select a valid Language from the dropdown.</f-alert>
    </div>
  </div>
      </div>

 <div class="email-deliver-method" *ngIf="getActiveStep() === onStep1Active">
  <p class="pin-content">
    Choose a delivery method:
  </p>
<!--CCR1-15052 OTC masking changes - Text needs to be updated once shared by Leslie-->
  <p>
    <f-alert variant="info" class="pin-content"
      *ngIf="rootScope.activeCustTab.otcData?.otcConfigData?.deliveryMethods?.length > 0">
      {{otcStep1InfoMsg}}
    </f-alert>
  </p>
  
  <p>
    <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.deliveryMethodSDataMiss">
      {{rootScope.activeCustTab.otcInsideFTU.hasAccountBalance ? noMobileNumberAvailableFtuOtcMsg : noDataOnFile }}
    </f-alert>
  </p>

<div *ngFor="let method of rootScope.activeCustTab.otcData?.otcConfigData?.deliveryMethods">

  <h6 *ngIf="method?.details?.length > 0" class="method-type">{{ method.type | titlecase }}</h6>

  <mat-radio-group color="primary" class="account-selection text-indent" disableRipple aria-label="Select an option"
    [(ngModel)]="rootScope.activeCustTab.otcData.selectedDeliveryMethod.details" (change)="onSelectionChange(method.type, $event.value)">

    <!-- <div *ngFor="let detail of (method?.details || [])">
      <mat-radio-button [value]="detail" >
        {{getDisplayOption(detail)}}
      </mat-radio-button>
    </div> -->
    <!-- Below code to be used by FE CCR3-13754 starts -->
     <div class="hide">
      <f-alert variant="error" class="status-msg"><p>Failed to remove the STOP status for the selected phone number.</p><p>Error detail- Invalid Country Code</p></f-alert>
      <p>Select the number where the One-time Code will be sent.</p>
      <p>Do not read any of the numbers below to the customer. The customer must provide and verify the number below, then you may select.</p>
     </div>
    <div *ngFor="let detail of (method?.details || [])" class="text-stopped-row hide1">
      <mat-radio-button [value]="detail" class="text-stopped-radio" [disabled]="isTextStopped(detail) || isTextBlocked(detail)">
        {{getDisplayOption(detail)}} <span *ngIf='isTextStopped(detail)' class="red">(<strong>Text Stopped</strong>)</span> <span *ngIf='isTextBlocked(detail)' class="red">(<strong>Text Blocked</strong>)</span>
        
      </mat-radio-button>
      <span  *ngIf='isTextStopped(detail) && getStopTextOptInConfig()' class="text-stopped-msg">Text messaging was previously stopped to this phone number. <a (click)="confirmUnblockMessage(detail)" href="javascript:void(0)">Click here</a> to receive text messages again.</span>
       <span  *ngIf='isTextBlocked(detail)' class="text-stopped-msg">Please see Security Guide-OTC Texts Blocked article for communication to participant</span>
    </div>
    <!-- CCR3-13754 ends -->
  </mat-radio-group>
</div>

<!-- CCR3-16400  Design for Contact Match within OTC Flow -->
  <mat-radio-group color="primary" class="hide account-selection text-indent" disableRipple
    aria-label="Custom Text option"
    [(ngModel)]="rootScope.activeCustTab.otcData.selectedDeliveryMethod.details"
    (change)="onSelectionChange(text, $event.value)">
    <div class=" hide custom-mobile-row">
      <mat-radio-button [value]="customMobileOption">
        <f-intl-tel-input defaultCountry="US" language="en-US"
          mandatory-country-code="true" label-text="Contact Match" helper-text=""
          appAutoCompleteOff class="clear-input">
        </f-intl-tel-input>
      </mat-radio-button>

      <!-- Verify number link with tooltip -->
       <span class=" hide custom-mobile-verification">
        <span class="custom-mobile-verification-text"><strong>Click here to verify number</strong></span>
        <f-tooltip content="Enter a mobile number associated with the Account Holder’s Name and Date of Birth to validate."
          position="right" variant="icon" trigger-event-type="hover"
          [iconConfig]="verificationTooltipIcon">
        </f-tooltip>
      </span>
       <!-- Verified number msg with tooltip -->
       <span class=" hide data-verified">
        <f-icon icon-config='{"iconName": "circle-check", "iconType": "solid", "iconSize": "s", "iconColor": "#107400"}'></f-icon>
        <span class="custom-mobile-status-text">Number matched! Proceed to OTC.</span>
        <f-tooltip content="Enter a mobile number associated with the Account Holder’s Name and Date of Birth to validate."
          position="right" variant="icon" trigger-event-type="hover"
          [iconConfig]="verificationTooltipIcon">
        </f-tooltip>
      </span> 
       <!-- Number not verified msg with tooltip -->
            <span class="hide data-not-verified">
        <f-icon icon-config='{"iconName": "times-circle", "iconType": "solid", "iconSize": "s", "iconColor": "#c61a1a"}'></f-icon>
        <span class="custom-mobile-status-text">Number not matched! <a href="javascript:void(0)" class="retry-number-link">Try a different number.</a></span>
         <f-tooltip content="Enter a mobile number associated with the Account Holder’s Name and Date of Birth to validate."
          position="right" variant="icon" trigger-event-type="hover"
          [iconConfig]="verificationTooltipIcon">
        </f-tooltip>
      </span>

    </div>
  </mat-radio-group>
  <div class="btn-controls">                    
    <f-button text="Continue" title="Continue" (click)="continueOnStep1()" [ngClass]="{'disableBtn': isSelectedDeliveryMethodEmpty() || isLocaleSelectionInvalid()}"[disabled]="isSelectedDeliveryMethodEmpty() || isLocaleSelectionInvalid()" type="button" variant="progressive" class=""></f-button>
  </div>
</div>

   <!-- Step 2 Confirm & Send  -->
  <div class="confirm-send" *ngIf="getActiveStep() === onStep2Active && !rootScope.activeCustTab.otcData.sendOTCSuccess">
      <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.notEligiblePhoneNumber" class="status-msg">{{notEligibleErrMsg}}</f-alert>
      <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.otcDenied" class="status-msg">{{deniedErrMsg}}</f-alert>
      <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.generateOTCApiFailure" class="status-msg">{{generateOtcApiFailErrMsg}}</f-alert>
    <p class="pin-content" *ngIf="!rootScope.activeCustTab.otcData.notEligiblePhoneNumber && !rootScope.activeCustTab.otcData.otcDenied">
      <!--CCR1-15052 OTC masking changes-->
      <span *ngIf="rootScope.activeCustTab.otcData.status !== 'OPTOUT000102' && rootScope.activeCustTab.otcData.status !== 'OPTOUT000100'">
        The one-time code will be sent to: <strong>{{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type !== 'email' ? rootScope.activeCustTab.otcData?.selectedCountryCode : ''}} {{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type === 'email' ? maskEmailForDisplay(rootScope.activeCustTab.otcData?.selectedEmail) : maskPhoneNumberForDisplay(rootScope.activeCustTab.otcData?.selectedPhoneNumber)}}</strong>. 
          
      </span>


      <span  *ngIf='rootScope.activeCustTab.otcData.status === "OPTOUT000102"' class="row-stop" >
        <strong>{{rootScope.activeCustTab.otcData?.selectedCountryCode}}:{{maskPhoneNumberForDisplay(rootScope.activeCustTab.otcData?.selectedPhoneNumber)}}</strong>
        <span class="red"><strong>(Text Stopped)</strong></span>
      <span class="text-stopped-msg">  Text messaging was previously stopped to this phone number. <a (click)="confirmUnblockMessage({countryCode: rootScope.activeCustTab.otcData?.selectedCountryCode, phoneNumber: rootScope.activeCustTab.otcData?.selectedPhoneNumber})" href="javascript:void(0)">Click here</a> to receive text messages again.
      </span>
      </span>

      <span  *ngIf='rootScope.activeCustTab.otcData.status === "OPTOUT000100"' class="row-stop" >
        <strong>{{rootScope.activeCustTab.otcData?.selectedCountryCode}}:{{maskPhoneNumberForDisplay(rootScope.activeCustTab.otcData?.selectedPhoneNumber)}}</strong>
        <span class="red"><strong>(Text Blocked)</strong></span>
       <span class="text-stopped-msg">Please see Security Guide-OTC Texts Blocked article for communication to participant.
      </span>
    </span>


    </p>

    <div class="btn-controls">
      <f-button text="Back" title="Back" (click)="backToStep1()" type="button" variant="action" class=""></f-button>
      <f-button text="Send OTC" title="Send OTC" type="button" 
      [ngClass]="{'disableBtn': (rootScope.activeCustTab.otcData.otcDenied) || (rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.generateOTCInProgress)  || (rootScope.activeCustTab.otcData.status === 'OPTOUT000102' || rootScope.activeCustTab.otcData.status === 'OPTOUT000100')}"  
      (click)="otcService.generateOTC()"variant="progressive"
       [disabled]="(rootScope.activeCustTab.otcData.otcDenied) || (rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.generateOTCInProgress) || (rootScope.activeCustTab.otcData.status === 'OPTOUT000102' || rootScope.activeCustTab.otcData.status === 'OPTOUT000100')"></f-button>
    </div>
  </div>
  
    <!-- Step 3 Enter OTC and Validate  -->
<div class="enter-otc" *ngIf="rootScope.activeCustTab.otcData.sendOTCSuccess">
         <div class="status-msg" *ngIf="!verifyCodeClicked && !rootScope.activeCustTab.otcData.validateOtcLocked && !rootScope.activeCustTab.otcData.validateOtcFail && !rootScope.activeCustTab.otcData.validateOtcApiFailure && !rootScope.activeCustTab.otcData.otcExpired">
        <f-alert variant="success" class="status-msg">Success! The One-Time Code has been sent.</f-alert>
         </div>
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.validateOtcLocked">
          <f-alert variant="error" class="status-msg">{{accountLockedMsg}}</f-alert>
        </div> 
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.validateOtcFail">
          <f-alert variant="error" class="status-msg">{{invalidOTCMsg}}</f-alert>
        </div>
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.validateOtcApiFailure">
          <f-alert variant="error" class="status-msg">{{validateOtcApiFailureMsg}}</f-alert>
        </div>  
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.otcExpired">
          <f-alert variant="error" class="status-msg">{{otcExpiredMsg}}</f-alert>
        </div> 

    <ul>
      <!--CCR1-15052 OTC masking changes-->
      <li >The One-Time Code has been sent to:<strong>{{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type !== 'email' ? rootScope.activeCustTab.otcData?.selectedCountryCode : ''}} {{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type === 'email' ? maskEmailForDisplay(rootScope.activeCustTab.otcData?.selectedEmail) : maskPhoneNumberForDisplay(rootScope.activeCustTab.otcData?.selectedPhoneNumber)}}</strong></li>
      <li>The One-Time Code is only valid for <strong>10 minutes </strong>. Once the code has been received by the customer, enter the code in the box below and click Verify Code.</li>        
    </ul>

  <div class="container">
    <div class="row">
    </div>
    <div class="row">
      <div class="col-md-6">
          <mat-form-field appearance="fill" class="component-box">
            <mat-label>One-Time Code</mat-label>
            <input
              [formControl]="otcService.oneTimeCode"
              matInput
              id="nid"
              placeholder="Enter {{otcService.otcLenght}}-digit code"
            />
            <mat-error *ngIf="otcService.oneTimeCode.hasError('required')">
              <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> Code is required
            </mat-error>
            <mat-error *ngIf="otcService.oneTimeCode.hasError('pattern')">
              <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> Invalid format, try again.
            </mat-error>
            <mat-error *ngIf="otcService.oneTimeCode.hasError('minlength') && !otcService.oneTimeCode.hasError('pattern')">
              <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> Code must be {{otcService.otcLenght}} characters
            </mat-error>
            <mat-error *ngIf="otcService.oneTimeCode.hasError('maxlength') && !otcService.oneTimeCode.hasError('pattern')">
              <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon> Code must be {{otcService.otcLenght}} characters
            </mat-error>
          </mat-form-field>
          
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="btn-controls">                  
          <f-button text="Cancel" title="Cancel" type="button" (click)="backToStep1()" variant="action" class=""></f-button>
          <f-button text="Verify Code" title="Verify Code" [ngClass]="{'disableBtn': otcService.oneTimeCode?.invalid || rootScope.activeCustTab.otcData.validateOtcLocked || rootScope.activeCustTab.otcData.validateOTCApiProcessing || rootScope.activeCustTab.otcData.otcExpired}" [disabled]="otcService.oneTimeCode?.invalid || rootScope.activeCustTab.otcData.validateOtcLocked || rootScope.activeCustTab.otcData.validateOTCApiProcessing || rootScope.activeCustTab.otcData.otcExpired" 
          variant="progressive" (click)="verifyCode()" type="button"></f-button>

        </div>
      </div>
    </div>
  </div>
</div>